import api from "@/data/services/api";
import {AuthMapper} from "@/data/mapper/auth.mapper";
import TokenService from "@/data/services/token.service"

export class AuthService {
  login(user) {
    console.log('login api', user);
    const request = AuthMapper.mapToLoginRequestJson(user);
    return api
      .post('/auth/login', request)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return AuthMapper.mapToToken(response.data.data);
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }

  logout() {
    TokenService.removeLocalAccessToken();
  }

  register() {
    // register
  }
}
